const getLastUserMessage = (chatMessages)=>{
    if (!chatMessages || 0 === chatMessages.length) return;
    for(let i = chatMessages.length - 1; i >= 0; i--)if ('user' === chatMessages[i].role) return chatMessages[i];
};
const getLastUserMessageContent = (chatMessages)=>{
    const lastUserMessage = getLastUserMessage(chatMessages);
    return lastUserMessage?.content || void 0;
};
export { getLastUserMessage, getLastUserMessageContent };
